import loadScript from './script-loader';

export function loadChat() {
  window.addEventListener('message', event => {
    if (event.data === 'hideZendesk') {
      if (window.zE) {
        hideChat();
      }
    }
  });

  loadScript(
    'https://static.zdassets.com/ekr/snippet.js?key=b4e35c30-14a2-4589-82e7-71d8bcaad6d0',
    {
      id: 'ze-snippet',
    }
  );
}
export function expandChat() {
  window.zE('messenger', 'open');
}

export function hideChat() {
  window.zE('messenger', 'hide');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/zendesk-chat.ts